angular.module('assets')
    .controller('AssetDocumentAcceptController', function ($rootScope, $uibModalInstance, toastr, data, AssetDocument) {

        this.$onInit = () => {
            this.item = data;
            this.nextStatus = (data.status === 'WAITING' && data.tag === 'SERVICE')? 'IN_PROGRESS' : 'FINISHED';
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled');

        this.save = () => {
            return AssetDocument.accept({id: this.item.id}).$promise.then(result => {
                $rootScope.$broadcast('asset-doc.updated');
                $uibModalInstance.close(result);
                toastr.success("Zapisano");
            })
        }
    })
